'use strict';

import pulse from '@finn-no/pulse-sdk';

window.addEventListener('load', () => {
  pulse.trackPageView({
    object: {
      type: 'Listing',
      layout: 'List',
    },
    vertical: {
      name: 'business_center',
    },
  });
});
